export const RAW_MESSAGE_ICON_DEFAULT_COLOR = '#9aa0a6';

const REGION_COLORS = {
  HK: '#d32f2f',
  US: '#1565c0',
};

export function rawMessageIconColor(accountKey) {
  const region = String(accountKey || '').toUpperCase().replace(/[^A-Z]/g, '');
  return REGION_COLORS[region] || RAW_MESSAGE_ICON_DEFAULT_COLOR;
}

export default rawMessageIconColor;
